import type { Driver, DriverMemberListResponse } from "./types";

export type DriverListResponse = Driver[] | DriverMemberListResponse;

export function fullDriversFromResponse(response: DriverListResponse | null): Driver[] {
  if (!response) return [];
  return Array.isArray(response) ? response : response.contracted;
}

export function visibleDriverCountFromResponse(response: DriverListResponse | null): number {
  if (!response) return 0;
  return Array.isArray(response)
    ? response.length
    : response.contracted.length + response.visible.length;
}
